import React from 'react';
import './Barcharts.scss';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import DataUnavailableMessage from '../../ui/DataUnavailableMessage';
const Barcharts = ({ target, achieved, dataEvent = [], currentFilter }) => {
  const data = [
    {
      name: 'Total',
      Target: target?.postpaidtarget + target?.prepaidtarget || 0,
      Achieved:
        achieved?.postCount +
        achieved?.preCount +
        ((currentFilter?.length === 2 ? 0 : dataEvent?.postCount + dataEvent?.preCount) || 0),
    },
    {
      name: 'Postpaid',
      Target: target?.postpaidtarget || 0,
      Achieved:
        achieved?.postCount + ((currentFilter?.length === 2 ? 0 : dataEvent?.postCount) || 0),
    },
    {
      name: 'Prepaid',
      Target: target?.prepaidtarget || 0,
      Achieved: achieved?.preCount + ((currentFilter?.length === 2 ? 0 : dataEvent?.preCount) || 0),
    },
    {
      name: 'Hup',
      Target: target?.hardwareupgrade || 0,
      Achieved: achieved?.hupCount + ((currentFilter?.length === 2 ? 0 : dataEvent?.hupCount) || 0),
    },
    {
      name: 'Addons',
      Target: target?.addon || 0,
      Achieved:
        achieved?.addonsCount + ((currentFilter?.length === 2 ? 0 : dataEvent?.addonsCount) || 0),
    },
  ];

  const isEmpty = data.every((item) => !item.Achieved && !item.Target);
  return (
    <>
      <div className={`line-chart ${isEmpty ? 'no-data' : ''}`}>
        {isEmpty ? (
          <DataUnavailableMessage customMessage={`No data available`} />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Target" fill="#1a80bb" />
              <Bar dataKey="Achieved" fill="#a00000" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </>
  );
};

export default Barcharts;
